import { extractYoutubeVideoIdFromUrl } from '@shared/dream-components';

import type { PodcastEpisode } from '~/interfaces/podcast';

/**
 * RSS episodes carry a matched `youtube_video_id`; beehiiv-hosted episodes carry the YouTube
 * link set on the episode form. Gated episodes have their platform links stripped by the API.
 */
export function getEpisodeYoutubeVideoId(podcastEpisode: PodcastEpisode): string | undefined {
  const youtubeLink = podcastEpisode.platform_links?.youtube;
  const extractedYoutubeVideoId = youtubeLink ? extractYoutubeVideoIdFromUrl(youtubeLink) : undefined;

  return podcastEpisode.youtube_video_id ?? extractedYoutubeVideoId ?? undefined;
}
